import React from 'react';

import type { SaveList, SaveListItem } from '../../../../types/save-types.js';
import type {
  ImageAsset,
  VideoAssetComponent,
} from '../../../../../core/data-sources/content-components/types.js';

import Image, { getImageUrl } from '../articleComponents/Image.js';
import { itemIsSaved } from '../../saving/utils.js';
import LoopingVideoAsset from '../articleComponents/LoopingVideoAsset/LoopingVideoAsset.js';

type IntroProps = {
  title: string;
  lead?: string;
  handleOverlay: (item: SaveListItem) => void;
  item: SaveListItem;
  mainImage?: ImageAsset;
  withIllustration?: boolean;
  colorPalette?: string;
  isMobile?: boolean;
  isFeature?: boolean;
  savedItems: SaveList[];
  loopingVideoIntro?: VideoAssetComponent | null;
};

export const Intro: React.FC<IntroProps> = ({
  title,
  lead,
  handleOverlay,
  item,
  mainImage,
  withIllustration = false,
  colorPalette,
  isMobile,
  savedItems,
  isFeature,
  loopingVideoIntro,
}) => {
  const illustration = withIllustration ? 'illustration' : '';
  const classNames = ['header', illustration, colorPalette].join(' ');
  const showFullWidthImage = !isMobile || isFeature;

  return (
    <div className={classNames}>
      {loopingVideoIntro && <LoopingVideoAsset {...loopingVideoIntro} />}
      {!loopingVideoIntro && mainImage && !withIllustration && (
        <Image
          imageAsset={mainImage}
          hideByline
          isMobile={isMobile}
          articleTitle={title}
          fullWidth={showFullWidthImage}
        />
      )}
      <div className="intro-text-wrapper">
        {!loopingVideoIntro &&
          mainImage &&
          mainImage.size &&
          withIllustration && (
            <img
              className="icon"
              src={getImageUrl(
                mainImage.id,
                mainImage.size.width,
                mainImage.size.height,
              )}
              alt="icon"
            />
          )}
        <div className="save-intro-container">
          <button className="save-intro" onClick={() => handleOverlay(item)}>
            {itemIsSaved(item, savedItems)
              ? 'Artikkelen er lagret'
              : 'Legg i liste'}
          </button>
        </div>
        <h1 className="title">{title}</h1>
        {lead && <p className="lead">{lead}</p>}
      </div>
    </div>
  );
};
